import React, { FC } from 'react';

// Styles
import './welcome-block.scss';

type TWelcomeBlockProps = {
  firstName: string;
};

export const WelcomeBlock: FC<TWelcomeBlockProps> = (
  { firstName }: TWelcomeBlockProps
) => {

  return (
    <div className="welcome-block">
      <div className="welcome-block--title">
        Welcome{ firstName ? ', ' + firstName : '' }!
      </div>
      <div className="welcome-block--subtitle">
        We're delighted to have you here. Wishing you a great experience as you manage the platform.
      </div>
    </div>
  );
}
